<div class="modals" v-if="hasActiveModals" :class="[currentModal, userStore.mobile ? 'modals--mobile' : '', sidebarAdjustment ? 'modals--sidebar' : '']">
    <div class="modals__modal" v-for="modal in modals" v-show="modal.active" :class="modal.class ? modal.class : ''">
        <div class="modal" v-if="modal.active">
            <div class="modal__close" v-if="modal.close" @click="closeModal(modal.name)">
                <i class="fa-solid fa-xmark"></i>
            </div>
            <div class="modal__loader" v-if="modal.loader && isSubmitting" :style="{ 'background-image': 'url(' + getStaticImages('loading', 'png') + ')' }"></div>
            <component :is="modal.comp" v-on:onSubmit="modal.loader ? loadLoader : ''"/>
        </div>
    </div>
</div>
